import { Controller } from "@hotwired/stimulus"

// Frame validation replaces the form. Restore keyboard focus to the first
// failing field, without moving focus on a successful section refresh.
export default class extends Controller {
  connect() {
    this.element.querySelector('[aria-invalid="true"]')?.focus()
  }
}
